export default __webpack_public_path__ + "static/media/034-walking dog.a4816965.svg";